export default __webpack_public_path__ + "img/mostly-cloudy-snow.c7c4a01.svg";